import { AuthenticationInterceptor } from 'Pods/Shared/CookieInterceptor/CookieInterceptor'
import {
  FilterTracker,
  CustomEventTracker,
  FooterNavigationTracker,
  HeaderNavigationTracker,
  CtaTracker,
} from 'Pods/Shared/UserTracker/UserTracker'
import { initSentry } from 'Utils/index'
import loadLocaleBundle from 'Translations/loadLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

var init = () => {
  initSentry(window)
  AuthenticationInterceptor()
  FilterTracker()
  CustomEventTracker()
  FooterNavigationTracker('app-footer')
  HeaderNavigationTracker('app-header')
  CtaTracker()

  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs");
    const context = require.context(
      'Pods',
      true,
      /\/UnifiedNavigation\/(?!.*(?:test|story).*$).*$/)

    ReactRailsUJS.useContext(context);
    ReactRailsUJS.mountComponents("#unified-navigation-components");
  })
}

document.readyState === 'complete' ? init() : window.addEventListener('load', init)
